import { Link } from "react-router-dom";
import styles from "./SideMenu.module.css";

export default function SideMenuStatic(props) {
  const { title, menus } = props;

  return (
    <div className={styles.SideMenu}>
      <div className={styles.Title}>{title}</div>
      {menus.map((menu, index) => {
        return (
          <div className={styles.Category} key={index}>
            <Link className={styles.CategoryName} to={menu.to}>
              {menu.title}
            </Link>
          </div>
        );
      })}
    </div>
  );
}
